import { render, staticRenderFns } from "./typeChose.vue?vue&type=template&id=024d4c35&scoped=true"
import script from "./typeChose.vue?vue&type=script&lang=js"
export * from "./typeChose.vue?vue&type=script&lang=js"
import style0 from "./typeChose.vue?vue&type=style&index=0&id=024d4c35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d4c35",
  null
  
)

export default component.exports